
import '@mlib/index.js';
import '@x3/index.js';

import router from '@parent/router';
import store from '@parent/store';
import App from './App.vue';

import api from '@parent/api/index.js';

import './config.js';

import './config/var.css';

Vue.config.productionTip = false;

Vue.prototype.$api = api;

Vue.prototype.showLoading = (str = '加载中...') => {
  vant.Toast.loading({
    message: str,
    forbidClick: true,
    loadingType: 'spinner',
    overlay: true,
    duration: 0,
  });
};

router.addRoutes(app.x3.side.sideRoutes);

// /* 错误日志收集，相关配置 */
// function sentryConfig() {
//   if (window.Sentry) {
//     Sentry.configureScope(function(scope) {
//       let company = [];
//       if (app.parent.user.companyList && app.parent.user.companyList.length > 0) {
//         app.parent.user.companyList.filter(item => {
//           return item.companyId == app.parent.user.companyId;
//         });
//       }
//       let cname = company.length > 0 && company[0].companyName,
//       uname = app.parent.user && app.parent.user.name;
//       /** 以公司名称作为用户信息 */
//       scope.setUser({
//         "_x3_机构名": cname,
//         "_x3_操作人": uname,
//       });
//       // 添加自定义标签
//       scope.setTag('_x3_operatorType_', 'parent');
//       scope.setTag('_x3_env_', process.env.VUE_APP_x3_env);
//       scope.setTag('_x3_company_', cname);
//     });

//     Vue.config.errorHandler = (err, vm, info) => {
//       console.log(err);
//       Sentry.captureMessage(err);
//     };
//   }
// }

// 加载微信sdk并进行config配置
function initWXConfig() {
  let query = app.tool.parseQuery(),
    companyId = '',
    productCode = '';
  if (Number(query.companyId)) {
    companyId = query.companyId;
  } else {
    productCode = 4;
  }

  let c = {},
    pm0 = app.base.getEnvSDKPromise,
    pm1 = api
      .getWxJsConfig({
        requestUrl: location.href.split('#')[0],
        companyId: companyId,
        productCode: productCode,
      })
      .then(res => {
        if (res.code == 200 && res.data) {
          c = res.data;
          return Promise.resolve(c);
        } else {
          return Promise.reject();
        }
      });

  return Promise.all([pm0, pm1]).then(res => {
    app.sdk.setConfig({
      config: {
        debug: false,
        appId: c.appId,
        timestamp: c.timestamp,
        nonceStr: c.nonceStr,
        signature: c.signature,
        openTagList: ['wx-open-launch-weapp'], // 填入打开小程序的开放标签名
      },
      customParams: {
        alertError: true, // 在微信SDK配置失败时，是否给出提示
      },
    });
  });
}


// 启动应用
function runSystem() {
  new Vue({
    el: '#app',
    router,
    store,
    template: '<app/>',
    components: {
      App,
    },
  });
}

function getParentForbidRoute(user) {
  if (!user) {
    return '';
  }

  let appOpenList = user.companyAppOpenList || [];
  let isForbidEnabled = appOpenList.indexOf('PARENT_LOGIN_FORBID') > -1;
  if (!isForbidEnabled || !user.companyId || user.companyId == 0 || !user.companyProduct) {
    return '';
  }

  if (user.companyProduct.productStatus == 0) {
    return '/parentForbid?type=stop';
  }

  if (user.companyProduct.expired) {
    return '/parentForbid?type=expired';
  }

  return '';
}

function replaceInitialHash(path) {
  let url = `${location.pathname}${location.search}#${path}`;
  history.replaceState(history.state, '', url);
}

// 如果是小程序 停用
if (app.base.env == 'wxxcx') {
  // location.href = `${location.origin}${location.pathname}${location.search}#/stop-xcx`
  router.replace('/stop-xcx');
  runSystem();
} else {
  // 获取用户信息
  store.dispatch('queryUserInfo').then(
    data => {
      // C端登录需要重新写一下token,登录之前是不知道机构的
      // 后端大佬说先去掉这段逻辑
      // if (data && data.token) {
      //     app.ls.set("x3-parent-token", data.token);
      //     app.http.setHeader("x3-authentication", data.token);
      // }

      // 机构过期/停用控制（仅在 PARENT_LOGIN_FORBID 开通时生效，机构id为0时跳过）
      let forbidRoute = getParentForbidRoute(data);
      if (forbidRoute) {
        replaceInitialHash(forbidRoute);
      }

      // sentryConfig();
      runSystem();

      // 下面做没有绑定任何机构跳转时
      // 相关商城相关域名不做跳转
      let whiteListNames = [
        /^#\/mall/, // 商城页面
        /^#\/detail/, // 商品详情页面
        /^#\/orderSubmit/, // 商品提交页面
        /^#\/studentSelect/, // 选择学员页面
        /^#\/studentInfo\?isFromOrder\=true/, // 添加学员页面
      ];
      for (let nameReg of whiteListNames) {
        if (nameReg.test(location.hash)) {
          return;
        }
      }
      // 不是以上白名单路由
      // 且没有默认的机构
      // 跳转切换机构页面进行登录机构切换或者换手机号码登录
      if (data && !data.companyId) {
        router.push('/switchCompany');
        return;
      }

     
    },
    err => {
      // sentryConfig();
      runSystem();
    }
  );

  initWXConfig();
}


// path: /baseClassCard 我的课时(上课统计)
// path: /face/home 到校记录(签到)
// path: /orderList    我的订单(订单管理)

Vue.mixin({
  vxshow() {
    // 机构过期/停用二次拦截（仅在 PARENT_LOGIN_FORBID 开通时生效，机构id为0时跳过）
    let user = app.tool.safeReadObjProp(app, 'parent.user') || {};
    let forbidRoute = getParentForbidRoute(user);
    if (forbidRoute && this.$vxRoute.path !== '/parentForbid' && this.$vxRoute.path !== '/switchCompany') {
      router.replace(forbidRoute);
      return;
    }

    let list = app.tool.safeReadObjProp(app, 'parent.user.parentMenuOpenList')
    if (list && list.length) {      
      if ((this.$vxRoute.path.indexOf('/baseClassStatistics') > -1 || this.$vxRoute.path.indexOf('/baseClassCard') > -1) && list.some(item=>item.menuCode === 'COURSE_STATISTICS' && item.openStatus == 0)) {
        router.replace('/home');
        setTimeout(() => {          
          vant.Toast('机构未配置“上课统计”')
        }, 1000);
      }
      if (this.$vxRoute.path.indexOf('/face/home') > -1 && list.some(item=>item.menuCode === 'FACEIN' && item.openStatus == 0)) {
        router.replace('/home');
        setTimeout(() => {  
          vant.Toast('机构未配置“到校记录”')
        }, 1000);
      }
      if (this.$vxRoute.path.indexOf('/orderList') > -1 && list.some(item=>item.menuCode === 'ORDER_MANAGE' && item.openStatus == 0)) {
        router.replace('/home');
        setTimeout(() => {  
          vant.Toast('机构未配置“我的订单”')
        }, 1000);
      }

      if (this.$vxRoute.path.indexOf('/vSelectStudent') > -1 && list.some(item=>item.menuCode === 'VZUOYE' && item.openStatus == 0)) {
        router.replace('/home');
        setTimeout(() => {  
          vant.Toast('机构未配置“练习”')
        }, 1000);
      }

      
    }
  }
})
app._app_port_ = 'parent';
